module.exports = {
  'selectLanguage': 'Select your language',
  '404Title': 'Page not found'
};